import React from 'react';
export var FormButtons = function FormButtons(props) {
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("button", {
    type: "submit",
    onClick: props.submit,
    disabled: !props.dirty || props.submitting
  }, "Submit"));
};